import { render } from "./singleeventlist.vue?vue&type=template&id=162fc64e&scoped=true"
import script from "./singleeventlist.vue?vue&type=script&lang=js"
export * from "./singleeventlist.vue?vue&type=script&lang=js"

import "./singleeventlist.vue?vue&type=style&index=0&id=162fc64e&scoped=true&lang=css"
import "./singleeventlist.vue?vue&type=style&index=1&id=162fc64e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-162fc64e"]])

export default __exports__